import { c as _c } from "react/compiler-runtime";
import { UploadFileEntityResponse } from "@lib/generated/graphql";
import { FC, useRef } from "react";
import { SwitchTransition, Transition } from "react-transition-group";
import StrapiImage from "../../../../components/StrapiImage";
const defaultTransitionStyle = {
  transition: "transform 200ms ease, opacity 200ms ease"
};
const transitionStyles: any = {
  entering: {
    opacity: 0,
    transform: "translateY(calc(-10%))",
    ...defaultTransitionStyle
  },
  entered: {
    opacity: 1,
    transform: "translateY(0)",
    ...defaultTransitionStyle
  },
  exiting: {
    opacity: 0,
    transform: "translateY(calc(10%))",
    ...defaultTransitionStyle
  },
  exited: {
    opacity: 0,
    ...defaultTransitionStyle
  },
  timeout: 200
};
const AccordionImage: FC<{
  image: UploadFileEntityResponse;
}> = t0 => {
  const $ = _c(5);
  const {
    image
  } = t0;
  const nodeRef = useRef(null);
  const t1 = image.data?.attributes?.url;
  let t2;
  if ($[0] !== image) {
    t2 = state => <div ref={nodeRef} className="h-full ml-3s relative" style={{
      ...transitionStyles[state]
    }}><StrapiImage sizes="700px" fill={true} className="object-contain object-center" image={image} /></div>;
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <SwitchTransition><Transition nodeRef={nodeRef} timeout={200} key={t1}>{t2}</Transition></SwitchTransition>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AccordionImage;